import { apiRequest, buildUrl } from './index';

export async function fetchAssetMedia(accessKey, fieldEngineerId, { signal } = {}) {
  const url = buildUrl(
    `/v1/assets/access_key/${encodeURIComponent(accessKey)}/media`,
    { field_engineer_id: fieldEngineerId }
  );
  return apiRequest(url, { signal });
}

export async function fetchAssetMediaDownload(accessKey, mediaId, fieldEngineerId, { signal } = {}) {
  const url = buildUrl(
    `/v1/assets/access_key/${encodeURIComponent(accessKey)}/media/${mediaId}/download`,
    { field_engineer_id: fieldEngineerId }
  );
  return apiRequest(url, { signal });
}
